import payload_plugin_ALLXFGgbCP from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt-vuefire/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/home/runner/work/livia_v0/livia_v0/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/home/runner/work/livia_v0/livia_v0/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_OVoKJro5pc from "/home/runner/work/livia_v0/livia_v0/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_BwfRt8ewMW from "/home/runner/work/livia_v0/livia_v0/node_modules/vue-sonner/lib/nuxt/runtime/plugin.js";
import plugin_client_pNVVgm7Ud2 from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt-vuefire/dist/runtime/app/plugin.client.js";
import vuefire_auth_plugin_client_cCwkwh1j5u from "/home/runner/work/livia_v0/livia_v0/.nuxt/vuefire-auth-plugin.client.mjs";
import plugin_mint_cookie_client_gJ7MNBxzVz from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt-vuefire/dist/runtime/auth/plugin-mint-cookie.client.js";
import vuefire_plugin_8cq4FnzXKb from "/home/runner/work/livia_v0/livia_v0/.nuxt/vuefire-plugin.mjs";
import plugin_client_sfZ68ONITJ from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt-amplitude-module/dist/runtime/plugin.client.mjs";
import plugin_client_UYiXMU8ZyN from "/home/runner/work/livia_v0/livia_v0/node_modules/nuxt-gtag/dist/runtime/plugin.client.js";
import fontawesome_7xXmPH2btU from "/home/runner/work/livia_v0/livia_v0/node_modules/@vesp/nuxt-fontawesome/dist/runtime/plugins/fontawesome.js";
import _1_rtvi_hpyMjtdYZb from "/home/runner/work/livia_v0/livia_v0/plugins/1.rtvi.js";
import _2_global_chatbot_dVOQqkTZf6 from "/home/runner/work/livia_v0/livia_v0/plugins/2.global-chatbot.js";
import posthog_client_o9IEgU9LwG from "/home/runner/work/livia_v0/livia_v0/plugins/posthog.client.js";
import vue_query_wrmMkNpEpe from "/home/runner/work/livia_v0/livia_v0/plugins/vue-query.ts";
export default [
  payload_plugin_ALLXFGgbCP,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_OVoKJro5pc,
  plugin_BwfRt8ewMW,
  plugin_client_pNVVgm7Ud2,
  vuefire_auth_plugin_client_cCwkwh1j5u,
  plugin_mint_cookie_client_gJ7MNBxzVz,
  vuefire_plugin_8cq4FnzXKb,
  plugin_client_sfZ68ONITJ,
  plugin_client_UYiXMU8ZyN,
  fontawesome_7xXmPH2btU,
  _1_rtvi_hpyMjtdYZb,
  _2_global_chatbot_dVOQqkTZf6,
  posthog_client_o9IEgU9LwG,
  vue_query_wrmMkNpEpe
]